import { DonorType } from "@nkr/enums/donor-type";

export interface IDonorCompliance {
    id: number,
    alias: string,
    donorType: DonorType,
    isAdp: boolean,
    recipientId: number,
    rdnManagingCenterId: number,
    complianceIssues: string[],
    itemCount: number
}